import { useCallback } from "react";
import useWorkspaceApiCall from "hooks/useWorkspaceApiCall";
import { deleteManyUsers } from "api/services/user-service";

export const useDeleteManyUsers = () => {
    const { callAPI, loading } = useWorkspaceApiCall(deleteManyUsers, 'deleteManyUsers.success', 'deleteManyUsers.error');

    const deleteUsersMethod = useCallback(async (userIds: string[]) => {
        return await callAPI({ userIds });
    }, [callAPI]);

    return { deleteManyUsers: deleteUsersMethod, deletingManyUsers: loading };
}